import type { ReceiptTemplate } from '../schema';

export const applePayTemplate: ReceiptTemplate = {
  id: 'apple-pay',
  name: 'Apple Pay Receipt',
  brand: 'APPLE PAY',
  description: 'Apple Pay transaction receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ap-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'APPLE PAY',
        businessNameFontSize: 18,
        addressLines: ['TRANSACTION RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ap-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans ID:', value: 'AP-847291034' },
          { id: 'merchant', label: 'Merchant:', value: 'MONSTERVILLE CAFE' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ap-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'amount', label: 'AMOUNT', value: '12.50', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ap-card',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'CARD: VISA ****4144\nDEVICE: IPHONE\nSTATUS: APPROVED', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'ap-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SUCCESSFUL', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: true },
    },
  ],
  updatedAt: new Date().toISOString(),
};

